// extracted by mini-css-extract-plugin
export default {"whatsappBtn":"Watsapbut_whatsappBtn__5VgDS"};